
define('template!ordersDetailPriceV2PriceView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (buying || currentBuying) { ;
__p += '\n<td class="pricev2-col-qty">\n  ';
 if (showCustomScaleIcon) { ;
__p += '<i class="mdi-action-assignment-late custom-scales-icon small" title="' +
((__t = ( _.i18n('price.customScale') )) == null ? '' : __t) +
'"></i>';
 } ;
__p += '\n  <span class="pricev2-qty-value">' +
((__t = ( buying?buying.quantity:currentBuying.quantity )) == null ? '' : __t) +
'</span>\n</td>\n<td>' +
((__t = ( buying?Number(buying.productUnitPrice).toFixed(2):currentBuying.productUnitPrice )) == null ? '' : __t) +
'&euro;</td>\n<td>' +
((__t = ( buying?buying.totalSetupCost:currentBuying.totalSetupCost )) == null ? '' : __t) +
'&euro;</td>\n<td>' +
((__t = ( buying?(buying.totalUnitCost / buying.quantity).toFixed(2):(currentBuying.totalUnitCost / currentBuying.quantity).toFixed(2) )) == null ? '' : __t) +
'&euro;</td>\n<td>' +
((__t = ( buying?buying.totalHandlingCost||'0':currentBuying.totalHandlingCost||'0' )) == null ? '' : __t) +
'&euro;</td>\n<td>' +
((__t = ( buying?buying.shippingCost:currentBuying.shippingCost )) == null ? '' : __t) +
'&euro;</td>\n<td>' +
((__t = ( buying?buying.expressShippingCost:currentBuying.expressShippingCost )) == null ? '' : __t) +
'&euro;</td>\n<td>' +
((__t = ( buying?buying.smallOrderFee?buying.smallOrderFee:0:currentBuying.smallOrderFee?currentBuying.smallOrderFee:0 )) == null ? '' : __t) +
'&euro;</td>\n<td class="pricev2-cell-editable pricev2-cell-buying-total">\n  <div class="pricev2-cell-stack">\n    <span class="pricev2-val-current">' +
((__t = ( currentBuying?currentBuying.total:'' )) == null ? '' : __t) +
'&euro;</span>\n    ';
 if (buying) { ;
__p += '\n    <div class="pricev2-val-editable">\n      <input type="text" class="txt-price pricev2-inline-input" value="' +
((__t = ( buying.total )) == null ? '' : __t) +
'"/>\n      <span class="lbl-price pricev2-inline-label clickable">' +
((__t = ( buying.total )) == null ? '' : __t) +
'&euro;</span>\n    </div>\n    ';
 } ;
__p += '\n  </div>\n</td>\n';
 } else { ;
__p += '\n<td class="pricev2-col-qty"></td>\n<td colspan="8"></td>\n';
 } ;
__p += '\n\n';
 if (selling && currentSelling) { ;
__p += '\n<td class="pricev2-cell-editable pricev2-cell-selling">\n  <div class="pricev2-cell-stack">\n    <span class="pricev2-val-current">' +
((__t = ( currentSelling?Number(currentSelling.totalUnit).toFixed(2)+'&euro;':'' )) == null ? '' : __t) +
'</span>\n    ';
 if (selling) { ;
__p += '\n    <div class="pricev2-val-editable">\n      <input type="text" class="txt-suprice pricev2-inline-input" value="' +
((__t = ( Number(selling.totalUnit).toFixed(2) )) == null ? '' : __t) +
'"/>\n      <span class="lbl-suprice pricev2-inline-label clickable">' +
((__t = ( Number(selling.totalUnit).toFixed(2) )) == null ? '' : __t) +
'&euro;</span>\n    </div>\n    ';
 } ;
__p += '\n  </div>\n</td>\n<td class="pricev2-cell-editable pricev2-cell-selling">\n  <div class="pricev2-cell-stack">\n    <span class="pricev2-val-current">';
 if (currentSelling) { ;
__p +=
((__t = ( Number(currentSelling.total).toFixed(2) )) == null ? '' : __t) +
'&euro;';
 } ;
__p += '</span>\n    ';
 if (selling) { ;
__p += '\n    <div class="pricev2-val-editable">\n      <input type="text" class="txt-sprice pricev2-inline-input" value="' +
((__t = ( selling.total )) == null ? '' : __t) +
'"/>\n      <span class="lbl-sprice pricev2-inline-label clickable">' +
((__t = ( Number(selling.total).toFixed(2) )) == null ? '' : __t) +
'&euro;</span>\n    </div>\n    ';
 } ;
__p += '\n  </div>\n</td>\n<td class="pricev2-cell-selling">\n  <div class="pricev2-cell-stack">\n    <span class="pricev2-val-current">';
 if (currentSelling) { ;
__p +=
((__t = ( currentSelling.expressShippingCost )) == null ? '' : __t) +
'&euro;';
 } ;
__p += '</span>\n    ';
 if (selling) { ;
__p += '<span class="pricev2-val-saved">' +
((__t = ( selling.expressShippingCost )) == null ? '' : __t) +
'&euro;</span>';
 } ;
__p += '\n  </div>\n</td>\n<td class="pricev2-cell-margin">\n  <div class="pricev2-cell-stack">\n    <span class="pricev2-val-current">';
 if (currentSelling) { ;
__p +=
((__t = ( currentSelling.unitMargin )) == null ? '' : __t) +
'&euro;';
 } ;
__p += '</span>\n    ';
 if (selling) { ;
__p += '<span class="pricev2-val-saved">' +
((__t = ( selling.unitMargin )) == null ? '' : __t) +
'&euro;</span>';
 } ;
__p += '\n  </div>\n</td>\n<td class="pricev2-cell-margin">\n  <div class="pricev2-cell-stack">\n    <span class="pricev2-val-current">';
 if (currentSelling) { ;
__p +=
((__t = ( currentSelling.totalMargin )) == null ? '' : __t) +
'&euro;';
 } ;
__p += '</span>\n    ';
 if (selling) { ;
__p += '<span class="pricev2-val-saved">' +
((__t = ( selling.totalMargin )) == null ? '' : __t) +
'&euro;</span>';
 } ;
__p += '\n  </div>\n</td>\n<td class="pricev2-cell-editable pricev2-cell-margin">\n  <div class="pricev2-cell-stack">\n    <span class="pricev2-val-current">';
 if (currentSelling) { ;
__p +=
((__t = ( currentSelling.percentMargin )) == null ? '' : __t) +
'%';
 } ;
__p += '</span>\n    ';
 if (selling) { ;
__p += '\n    <div class="pricev2-val-editable">\n      <input type="text" class="txt-margin pricev2-inline-input" value="' +
((__t = ( selling.percentMargin )) == null ? '' : __t) +
'"/>\n      <span class="lbl-margin pricev2-inline-label clickable">' +
((__t = ( selling.percentMargin )) == null ? '' : __t) +
'%</span>\n    </div>\n    ';
 } ;
__p += '\n  </div>\n</td>\n<td class="pricev2-col-status">\n  <div class="pricev2-cell-stack">\n    <span class="pricev2-status-badge pricev2-status-new">new</span>\n    ';
 if(selling && selling.priceCustom && selling.priceCustom.totalPrice) { ;
__p += '\n    <span class="pricev2-status-badge pricev2-status-manual">manual</span>\n    ';
 } else { ;
__p += '\n    <span class="pricev2-status-badge pricev2-status-saved">saved</span>\n    ';
 } ;
__p += '\n  </div>\n</td>\n';
 } else { ;
__p += '\n<td>\n  <div class="pricev2-cell-stack">\n    <span class="pricev2-val-current"></span>\n    <span class="pricev2-val-saved">' +
((__t = ( selling?Number(selling.totalUnit).toFixed(2)+'&euro;':'' )) == null ? '' : __t) +
'</span>\n  </div>\n</td>\n<td>\n  <div class="pricev2-cell-stack">\n    <span class="pricev2-val-current"></span>\n    <span class="pricev2-val-saved">';
 if (selling) { ;
__p +=
((__t = ( selling.total )) == null ? '' : __t) +
'&euro;';
 } ;
__p += '</span>\n  </div>\n</td>\n<td colspan="4"></td>\n';
 } ;
__p += '\n';

}
return __p
};});

